import useAbortController from '@hook/useAbortController'
// import SVGSchool from '@img/school.svg'
import SVGProperty from '@img/property.svg'
import imgDe from '@img/devlopment/de.png'
import useStorage from '@hook/useStorage'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { debounce, forEach, intersection, isArray, isString, map, pick } from 'lodash-es'
import { useLocale, useTranslations } from 'use-intl'
import { useMap } from 'react-map-gl'
import { fetchGet } from '@lib/fetch/client'
import { getMapboxBounds } from '@comp/page/search/mix/lib'
import { isAU, isNZ, isValid } from '@lib/utils'
import { useMapState } from '@comp/mapbox'
import useFetch from '@hook/useFetch'

/**
 * 获取地图控制菜单
 */
export function useMenuOptions({ location }) {
  const locale = useLocale()
  const ts = useTranslations('search')

  const storageName = `HG_${process.env.NEXT_PUBLIC_COUNTRY}_${locale}_MAPBOX_DEVELOPMENT_MENU`
  const mrl = useStorage(storageName, true)
  const cache = mrl.getItem()
  const { data, isLoading } = useFetch(cache ? null : 'map-dev-menu')

  useEffect(() => { !cache && data && mrl.setItem(data) }, [cache, data, mrl])
  
  return useMemo(() => {
    const menus = [] // 所有菜单
    const devMenus = [] // 房产开发菜单(房源详情用)
    const hashMenus = {} // 所有菜单的value作为键值

    const target = cache || data
    
    isArray(target) && forEach(target, (it) => {
      const items = []

      isArray(it.items) && forEach(it.items, (child) => {
        const local = isArray(child.locations) ? child.locations : []
        const tmp = pick(child, ['label', 'value', 'subTitle', 'icon', 'badge'])
        
        // 图层描述
        let des
        if(child.description) {
          forEach(location, (key) => {
            child.description[key] !== undefined && (des = child.description[key])
          })
          des = (des !== undefined ? des : child.description.default)
          des && (tmp.description = des)
        }

        if(local.length === 0 || intersection(location, local).length > 0) {
          child.showDetail && devMenus.push(tmp)
          
          items.push(tmp)
          hashMenus[child.value] = tmp
        }
      })

      // 政府公屋（新西兰才有）
      if(isNZ && it.value === 'development') {
        const opt = {
          label: ts('governmentHousing'),
          value: 'governmentHousing',
          icon: imgDe
        }

        devMenus.push(opt)
        isNZ && items.push(opt)
      }
      
      items.length > 0 && menus.push({
        label: it.label,
        value: it.value,
        items,
      })
    })
    
    return {
      menus,
      hashMenus,
      devMenus,
      isLoading
    }
  }, [data, cache, location, ts, isLoading])
}

export function useLocaionBarInitial() {
  const [optionValue, setOptionValue] = useState([])
  const [tabName, setTabName] = useState('')
  const [tabValue, setTabValue] = useState('')

  const handleClose = useCallback(() => {
    setTabValue('')
    setTabName('')
    setOptionValue([])
  }, [])

  /**
   * @param {Object} d
   * @param {Boolean} isMultiple 是否多选操作
   */
  const handleChange = useCallback((d, isMultiple = false) => {
    if(d.tabName !== undefined) {
      setTabName(d.tabName)
    }

    if(d.tabValue !== undefined) {
      setTabValue(d.tabValue)
    }

    if(d.optionValue !== undefined) {
      let target = []

      if(d.optionValue) {
        target = [...optionValue]

        // 保存只是当前类型的 key
        if(isArray(d.opt?.children)) {
          const limitKeys = map(d.opt.children, 'value')
          target = target.filter((f) => limitKeys.indexOf(f) > -1)
        }

        target = isMultiple ? target : [d.optionValue]
        if(isMultiple) {
          const index = target.indexOf(d.optionValue)
          if(index > -1) {
            target.splice(index, 1)
          } else {
            target.unshift(d.optionValue)
          }
        }
      }

      // 如果没有选项，则关闭面板
      if(target.length === 0) {
        handleClose()
      }

      setOptionValue(target)
    }
  }, [optionValue, handleClose])

  const handleShow = useCallback((/* { key, layers } */) => {
    // if(key === 'development') {
    //   mps.valueSetter(key, true)
    //   setTabValue(key)

    //   const opt = filter(optionValue, (f) => layers.indexOf(f) > -1)

    //   if(opt.length === 0) {
    //     // NZ: 删除政府公屋, AU: 只展示土地规划
    //     const tmp = layers.filter((v) => (
    //       isAU ? v === 'landPlan' : v !== 'governmentHousing'
    //     ))
        
    //     setOptionValue(tmp)
    //   }
    // }
  }, [])
  
  return {
    optionValue,
    tabName,
    tabValue,
    handleClose,
    handleChange,
    handleShow
  }
}

/**
 * 获取地图options
 */
export function useLocationBarOptions(type, param) {
  const mps = useMapState()
  const { menus } = useMenuOptions(mps.extra)
  
  const { stateId } = param || {}
  const { current: mapbox } = useMap()
  const { getSignal } = useAbortController()

  const getZoomInfo = useCallback(() => {
    const { rect } = getMapboxBounds(mapbox)
    const { signal } = getSignal()
    
    fetchGet('zoom-n-center', { rect }, { signal }).then((data) => {
      const tmp = { ...data }
      if(data) {
        tmp.districtId = isArray(tmp.districtId) ? tmp.districtId : [tmp.districtId]
        tmp.isCanterbury = tmp.regionId.indexOf(45) > -1 // 坎特伯雷
      }

      const position = tmp.isCanterbury ? 'canterbury' : ''
      const realStateId = isValid(stateId) 
        ? stateId 
        : isString(tmp.state) 
          ? tmp.state.toLowerCase() 
          : null

      // 判断location
      let location = []
      if(isAU && realStateId) location = [realStateId]
      if(isNZ && isArray(data?.regionId)) location = data.regionId

      mps.valueSetter('extra', {
        ...tmp,
        ...param, 
        stateId: realStateId,
        position,
        location
      })
    })
  }, [mapbox, getSignal, stateId, mps, param])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { getZoomInfo() }, [type])
  useEffect(() => {
    const handleMoveEnd = debounce(getZoomInfo, 500)
    mapbox.on('moveend', handleMoveEnd)
    return () => { mapbox.off('moveend', handleMoveEnd) }
  }, [getZoomInfo, mapbox])

  const options = useMemo(() => {
    const tmp = [
      // { 
      //   label: ts('surroundingSchools'), 
      //   value: 'schoolPanel', 
      //   icon: <SVGSchool /> 
      // },
    ]

    forEach(menus, (opt) => {
      tmp.push({
        label: opt.label,
        value: opt.value,
        icon: <SVGProperty />,
        children: opt.items,
        multiple: true,
      })
    })

    return tmp
  }, [menus])
  
  return { options }
}
